// Browser `btoa`/`atob` operate on Latin-1 binary strings, so feeding them a
// JS string containing characters above U+00FF throws, and characters in
// U+0080–U+00FF (e.g. "é") silently round-trip through a single byte instead
// of their UTF-8 multi-byte sequence. The gateway's `Base64` scalar passes
// raw bytes to pydantic, which expects UTF-8, so we must encode to UTF-8
// bytes first and decode from UTF-8 bytes on the way back.

export function toBase64(value: string): string {
  const bytes = new TextEncoder().encode(value)
  let binary = ''
  for (const byte of bytes) {
    binary += String.fromCodePoint(byte)
  }
  return btoa(binary)
}

export function fromBase64(value: string): string {
  const binary = atob(value)
  const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0))
  return new TextDecoder().decode(bytes)
}
